export default __webpack_public_path__ + "static/media/icono-reportar-ok.6f70a9c3.svg";